// import Navbar from "./components/Navbar";
import { InstagramSMIcon, WhatsAppSMIcon } from "./components/Icons";
import Home from "./pages/Home";

function App() {
	return (
		<div className="App">
			<Home />
		</div>
	);
}

export default App;
